{
  "lang": "nl",
  "alias": "rvr-ehbo",
  "theme": "rvr",
  "master": "./masters/rvr/jumplist",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-user-detect",
    "asterisk",
    "bb-input-wrap-and-unit",
    "custom-checkboxes",
    "dialog",
    "final-node",
    "hacks:preview-md",
    "hacks:preview-path",
    "has-required",
    "heading2-3",
    "high-on-info-tb",
    "history",
    "md-labels",
    "model-filter",
    "modelitem",
    "no-login",
    "no-menu",
    "non-indenting-jumplist",
    "nonce-metatag",
    "nta:proxymap",
    "optional",
    "piwik-pro-nonce",
    "previews",
    "progressbar",
    "questionlabelgroup-ng",
    "reset-password",
    "selected-model",
    "show-server-side-validation",
    "showdown",
    "showdown-converter",
    "xsl-to-pdf"
  ],
  "overrideinloghtml": "ehbo.html",
  "a11y": {
    "captions": false,
    "optionfieldsets": true,
    "strictlegends": true
  },
  "arbitrary": {
    "jumplisttitle": "Stappen:",
    "showdown": {
      "policy": "legacy"
    },
    "core": {
      "skipNumButtons": true
    },
    "piwik": {
      "fallback": {
        "code": "1cb006c7-51c6-4a48-a7bf-ebd3e28b0fd1",
        "endpoint": "https://rvr.containers.piwik.pro/"
      }
    },
    "previews": {
      "autoload": true,
      "singular": true,
      "showChanges": false,
      "only": {
        "Rechtwijzer_EHBO": {
          "main": {
            "document": true
          }
        },
        "Rechtwijzer_EHBO_RW": {
          "main": {
            "document": true
          }
        }
      }
    }
  },
  "template": {
    "logo": "logo-EHBO-beta",
    "less": {
      "post": [
        "jumplist.less"
      ]
    },
    "readonly-prop": "disabled"
  },
  "legacy": false
}
